import React, { useEffect, useState } from 'react';
import {
  CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter,
  CButton, CFormLabel, CFormInput, CFormTextarea, CAlert, CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSend, cilPhone } from '@coreui/icons';
import api from '../services/api';

export default function SmsModal({ jobcode, hid, type, visible, onClose, onSent }) {
  const [phone, setPhone]     = useState('');
  const [mesej, setMesej]     = useState('');
  const [catatan, setCatatan] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult]   = useState('');
  const [error, setError]     = useState('');

  useEffect(() => {
    if (!visible || !jobcode) return;
    setResult('');
    setError('');
    api.get(`/sms/${jobcode}`, { params: { hid, type } })
      .then(r => {
        setPhone(r.data.mobile || '');
        setMesej(r.data.defaultMessage || '');
        setCatatan('');
      })
      .catch(() => setError('Failed to load SMS form.'));
  }, [visible, jobcode, hid, type]);

  async function handleSend() {
    if (!phone || !mesej) return;
    setSending(true);
    setResult('');
    setError('');
    try {
      const { data } = await api.post(`/sms/${jobcode}`, { phone, mesej, catatan, hid, type });
      setResult(data.message);
      if (onSent) onSent();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send SMS.');
    } finally {
      setSending(false);
    }
  }

  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CModalHeader>
        <CModalTitle>
          <CIcon icon={cilPhone} className="me-2" style={{ color: '#8bc34a' }} />
          Send SMS — {jobcode}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        {error  && <CAlert color="danger"  className="py-2">{error}</CAlert>}
        {result && <CAlert color="success" className="py-2">{result}</CAlert>}

        <div className="mb-3">
          <CFormLabel>Phone Number</CFormLabel>
          <CFormInput value={phone} onChange={e => setPhone(e.target.value)} placeholder="e.g. 0123456789" />
        </div>
        <div className="mb-3">
          <CFormLabel>Message</CFormLabel>
          <CFormTextarea rows={5} value={mesej} onChange={e => setMesej(e.target.value)} />
          <div className="text-end mt-1" style={{ fontSize: 12, color: '#aaa' }}>{mesej.length} chars</div>
        </div>
        <div className="mb-1">
          <CFormLabel>Note (internal only)</CFormLabel>
          <CFormInput value={catatan} onChange={e => setCatatan(e.target.value)} placeholder="e.g. new job notification" />
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" variant="outline" onClick={onClose}>Cancel</CButton>
        <CButton color="success" onClick={handleSend} disabled={sending || !phone || !mesej}>
          {sending ? <CSpinner size="sm" className="me-2" /> : <CIcon icon={cilSend} className="me-2" />}
          {sending ? 'Sending…' : 'Send SMS'}
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
